export default __webpack_public_path__ + "static/media/search.55b94d98.svg";